import styled from 'styled-components'

export default styled.div`
  background: ${props => props.theme.mobileTabs.background};
  margin-bottom: 10px;
  padding: 8px;
  position: relative;
`
